import { QueryClient } from "@tanstack/react-query";

// let invalidatedQueryKeys: string[] = [];

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      keepPreviousData: false,
      retry: 0,
      staleTime: 1000 * 30 * 1,
      cacheTime: 1000 * 60 * 1,
      notifyOnChangeProps: ['data'],
    },
    mutations: {
      retry: 0,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 5000),
      onSuccess: (data) => console.log('Success:', data),
      onError: (error) => console.log('Error:', error),
    },
  },
});

export default queryClient;